import React from 'react';
import { Shield } from 'lucide-react';

export default function PunishmentTab() {
  return (
    <div className="space-y-6">
      <div>
        <h3 className="text-lg font-semibold">Data Punishment</h3>
        <p className="text-gray-500 text-sm">Riwayat hukuman disiplin (View Only)</p>
      </div>
      <div className="text-center py-12 text-gray-500">
        <Shield className="w-16 h-16 mx-auto mb-4 text-gray-300" />
        <p>Data punishment dikelola melalui modul terpisah</p>
        <p className="text-sm mt-2">Hubungi HRD untuk informasi lebih lanjut</p>
      </div>
    </div>
  );
}
